import { lazy } from 'react'

export const UpdateLicenseModalAsync = lazy(() =>
    import('./UpdateLicenseModal').then((module) => ({
        default: module.UpdateLicenseModal,
    }))
)
